import { useQuery } from '@tanstack/react-query';
import { mockDelay } from '@/shared/api/mockDelay';
import { buildDocumentRecordDetail, documentRecords, documentVersions } from './mockData';

/** GET /api/documents/records */
export function useDocumentRecords() {
  return useQuery({
    queryKey: ['documents', 'records'],
    queryFn: () => mockDelay(documentRecords),
  });
}

/** GET /api/documents/versions */
export function useDocumentVersions() {
  return useQuery({
    queryKey: ['documents', 'versions'],
    queryFn: () => mockDelay(documentVersions),
  });
}

/** GET /api/documents/records/:id */
export function useDocumentRecord(id: number) {
  return useQuery({
    queryKey: ['documents', 'records', 'detail', id],
    queryFn: async () => {
      const rec = documentRecords.find((r) => r.id === id);
      if (!rec) return null;
      return mockDelay(buildDocumentRecordDetail(rec));
    },
    enabled: Number.isFinite(id) && id > 0,
  });
}
